import React from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Assessment, ExpandLess, ExpandMore } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EventIcon from "@mui/icons-material/Event";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { useNavigate } from "react-router-dom/dist";

const PREFIX = "BottomMenu";

const classes = {
  bottomMenuIcon: `${PREFIX}-bottomMenuIcon`,
  speedDial: `${PREFIX}-speedDial`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.bottomMenuIcon}`]: {
    width: "30px",
    height: "30px",
    margin: "0 auto",
    color: "#D3AF5F",
    transform: "translateY(5px)",
  },

  [`& .${classes.speedDial}`]: {
    position: "fixed",
    zIndex: "99",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
    "& > div > span > span": {
      color: "rgba(255, 255, 255, 0.7)",
      fontWeight: "400",
    },
  },
}));

export default function BottomAppBar() {
  const { t } = useTranslation();
  const history = useNavigate();
  const loggedIn = useSelector((state) => state.user.loggedIn);
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const crmToggle = useSelector((state) => state.myDesigns?.crmEnabled);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const bottomMenuIcons = [
    {
      name: t("bottomMenu.home"),
      route: "/",
      renderer: (
        <Root>
          <HomeIcon className={classes.bottomMenuIcon} />
        </Root>
      ),
    },
    {
      name: t("bottomMenu.upload"),
      route: "/upload",
      renderer: (
        <Root>
          <CloudUploadIcon className={classes.bottomMenuIcon} />
        </Root>
      ),
    },
    {
      name: t("bottomMenu.schedule"),
      route: "/schedule",
      renderer: (
        <Root>
          <EventIcon className={classes.bottomMenuIcon} />
        </Root>
      ),
    },
    {
      name: t("bottomMenu.statistics"),
      route: "/statistics",
      renderer: (
        <Root>
          <Assessment className={classes.bottomMenuIcon} />
        </Root>
      ),
    },
  ];

  return loggedIn &&
    location.pathname.indexOf("mobile") < 0 &&
    !location.pathname.includes("player") &&
    !location.pathname.includes("create") &&
    !location.pathname.includes("/admin/models") &&
    !location.pathname.includes("/m/") &&
    !location.pathname.includes("/leaderboard") &&
    !location.pathname.includes("/myExpariences/") &&
    !location.pathname.includes("webview") &&
    !location.pathname.includes("purchased-geoloc") &&
    !(location.pathname.includes("mydesign") && crmToggle) &&
    !location.pathname.includes("public") ? (
    <Root>
      <SpeedDial
        ariaLabel="Menu"
        className={classes.speedDial}
        icon={<SpeedDialIcon icon={<ExpandLess />} openIcon={<ExpandMore />} />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction="up"
      >
        {bottomMenuIcons.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.renderer}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={() => {
              history(action.route);
              handleClose();
            }}
          />
        ))}
      </SpeedDial>
    </Root>
  ) : null;
}
